import { HiArrowRightOnRectangle } from "react-icons/hi2";
import { Button } from "../../components/ui/button";
import { signOut } from "supertokens-auth-react/recipe/session";

function LogoutButton() {
  async function onLogout() {
    await signOut();
    window.location.href = "/auth/signin";
  }
  return (
    <Button onClick={onLogout} variant="secondary" className="flex flex-1 gap-4">
      <HiArrowRightOnRectangle /> Logout
    </Button>
  );
}

export default LogoutButton;
// user id, logged in or not
